import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "@mui/material";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import {
  lenderFieldConfiguration,
  lenderInitialValues,
} from "../../../formConfigs/Fleet/lenderFieldConfig";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";

const LenderPopup = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const { token } = useAuth();

  const lenderMutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/lender`, data, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    onSuccess: () => {
      setStatus("success");
      setOpen(false);
      queryClient.invalidateQueries({ queryKey: ["lenders"] });
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response?.data || "Failed to submit lender");
    },
  });

  const submitHandler = (data: any) => {
    lenderMutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Create Lender
      </Button>
      <GenericFormPopup
        formFields={lenderFieldConfiguration}
        initialValues={lenderInitialValues}
        title="Lender Form"
        onSubmit={submitHandler}
        open={open}
        onClose={() => setOpen(false)}
        loading={lenderMutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage="Lender added successfully"
        errorMessage={errorMessage}
        handleClose={() => setStatus("idle")}
      />
    </>
  );
};

export default LenderPopup;
